import React from 'react'
import BaseComponent from "../pages/base/BaseComponent";
import {Button, Col, Form, Modal, Row, Table} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label"
import Endpoint from "enqc-utilities/src/api/Endpoint";
import PropTypes from 'prop-types';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFilter} from "@fortawesome/free-solid-svg-icons";
import PaginationTop from "./PaginationTop";
import SearchInput from "./input/SearchInput";
import {DD_MMMM_YYYY_HH_MM_SS} from "../utils/Global";
import {parseDate} from "enqc-utilities/src/utils/Utilities";

export default class ModelCategoryFilterModal extends BaseComponent{

    constructor(props) {
        super(props);
        this.state = {
            selectedModelCategories:new Set([]),
            search:"",
            modelCategories:[],
            modelCategory:{},
            sortOption:{},
            page:1,
            totalPage: 0,
            totalElement: 0,
            pageElement: 0,
            show:false
        }
    }

    componentDidMount() {
        super.componentDidMount();
    }

    addModelCategorySelectedId(object){
        let {selectedModelCategories} = this.state
        selectedModelCategories.add(object)
        this.setState({selectedModelCategories})
    }

    removeModelCategorySelectedId(object){
        let {selectedModelCategories} = this.state
        let objectToDelete = undefined ;
        selectedModelCategories.forEach((item)=>{
            if(item.id===object.id){
                objectToDelete = item
            }
        })
        if(objectToDelete){
            selectedModelCategories.delete(objectToDelete)
        }
        this.setState({selectedModelCategories})
    }

    exists(object){
        let {selectedModelCategories} = this.state
        let has = false ;
        selectedModelCategories.forEach((item)=>{
            if(item.id===object.id){
                has = true
            }
        })
        return has
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps!=this.props){
            let show = nextProps.show?nextProps.show:false
            let selectedModelCategories = nextProps.selectedModelCategories
            let prevState = this.state
            let search = prevState.search
            if(show && !prevState.show){
                search = ''
            }
            this.setState({show, selectedModelCategories, search},() => {
                if(show && !prevState.show){
                    this.fetchModelCategories(null)
                }
            })
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps!=this.props){
            let show = this.props.show?this.props.show:false
            let selectedModelCategories = this.props.selectedModelCategories
            this.setState({show, selectedModelCategories},() => {
                if(show){
                    // window.history.pushState({ show: true }, '');
                    this.handlePopState = (event) =>{
                        if (show) {
                            this.props.onClose()
                            // window.history.pushState(null, ''); // re-push state to prevent deep back
                            window.history.pushState({ show: true }, '');
                        }
                    }
                    window.addEventListener('popstate', this.handlePopState);
                    this.fetchModelCategories(null)
                }else{
                    window.removeEventListener('popstate', this.handlePopState);
                }
            })
        }

    }

    fetchModelCategories(){
        let {modelCategory, sortOption, search} = this.state
        this.get(Endpoint.API.MODEL_CATEGORIES, {
            params :{
                ascending: sortOption.ascending,
                sortir: sortOption.sortir,
                page: this.state.page - 1,
                search:search
            }
        }, null, response=>{
            if(response.code===200){
                let modelCategories = response.data
                let totalPage = response.totalPage
                let totalElement = response.totalElement
                let pageElement = response.pageElement
                this.setState({modelCategories:modelCategories,totalPage, totalElement, pageElement})
            }else{
                this.props.history.goBack();
            }
        }, false, true)
    }

    onSelect(modelCategory){
        if(this.props.onSelect){
            this.props.onSelect(modelCategory);
        }
    }




    render() {
        let {modelCategories,show, selectedModelCategories, page,totalPage, totalElement, pageElement} = this.state
        return (
            <>
                {super.render()}
                <Modal as={Modal.Dialog} size="xl" centered show={show} onHide={()=>{}}>
                    <Modal.Header>
                        <Modal.Title className="h6">{label.SelectModelCategory}</Modal.Title>
                        <Button variant="close" aria-label="Close" onClick={()=>{
                            this.props.onClose()
                        }} />
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col md={4} className="mb-3">
                                <SearchInput
                                    onEnter={(search) => {
                                        this.setState({search, page:1}, () => {
                                            this.fetchModelCategories()
                                        })
                                    }} onEmpty={() => {
                                    this.setState({search:"", page:1}, () => {
                                        this.fetchModelCategories()
                                    })
                                }}/>
                            </Col>
                            <Col md={8} className="text-right mb-3">
                                <PaginationTop
                                    onSelect={(page) => {
                                        this.setState({page}, () => {
                                            this.fetchModelCategories()
                                        })
                                    }}
                                    currentPage={page}
                                    pageCount={totalPage}
                                    totalElement={totalElement}
                                    showingRow={page}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Table responsive className="table-responsive table-sm align-items-center table-flush p-0">
                                    <thead className="thead-light">
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">{label.Name}</th>
                                        <th scope="col" className="text-center">{label.Select}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {modelCategories.map((item, index) => {
                                        return (
                                            <tr>
                                                <th scope="row">
                                                    {((page - 1) * pageElement) + (index+1)}
                                                </th>
                                                <th scope="row" className="text-wrap">
                                                    {item.name}
                                                </th>
                                                <td scope="col" className="text-center">
                                                    <Form.Check
                                                        size="lg"
                                                        id="checkbox1"
                                                        htmlFor="checkbox1"
                                                        checked={this.exists(item)}
                                                        onChange={event => {
                                                            if(this.exists(item)){
                                                                this.removeModelCategorySelectedId(item)
                                                            }else{
                                                                this.addModelCategorySelectedId(item)
                                                            }
                                                        }}
                                                        className="pl-3"
                                                        label="" />
                                                </td>
                                            </tr>
                                        )
                                    })}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            size="sm"
                            variant="success"
                            onClick={event => {
                                let selectedModelCategories = new Set([])
                                this.setState({
                                    selectedModelCategories
                                }, () => {
                                    this.props.onSelect(selectedModelCategories)
                                })
                            }}>
                            {label.ResetFilter}
                        </Button>
                        <Button
                            variant="info"
                            size="sm"
                            onClick={event => {
                                this.props.onSelect(selectedModelCategories)
                            }}>
                            {label.ApplyFilter}
                            &nbsp;
                            {label.Selected_Count(selectedModelCategories.size?selectedModelCategories.size:0)}
                            &nbsp;
                            <FontAwesomeIcon size="sm" icon={faFilter} />
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }

}
ModelCategoryFilterModal.propTypes = {
    show:PropTypes.bool.isRequired,
    onClose:PropTypes.func.isRequired,
    onSelect:PropTypes.func.isRequired,
    selectedModelCategories:PropTypes.any

}
